// extracted by mini-css-extract-plugin
export default {"statusLabel":"info-label_statusLabel__C-XtY","icon":"info-label_icon__PBS-W"};